import { render } from "./EmployeeImmigration.vue?vue&type=template&id=6c4a1670&scoped=true"
import script from "./EmployeeImmigration.vue?vue&type=script&lang=js"
export * from "./EmployeeImmigration.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=6c4a1670&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4a1670"]])

export default __exports__